<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o0bd25/tc-custom/9781480443877.jpg?1706911211024" alt="This image is the cover for the book Holiday with Violence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Holiday with Violence
      </h1>
      <p class="bookDescription body article font2">
        <b>English teens on vacation in Italy are caught up in a murderous conspiracy, from the Edgar Award–winning author of the Chronicles of Brother Cadfael.</b><br/>  <br/> On a train ride across Northern Italy, a quartet of young English tourists en route to Venice are charmed by a kindly older fellow passenger. Inviting them into his first-class compartment, their new friend, Signore Galassi, beguiles them with stories, anecdotes, and fascinating facts about the lush Italian countryside.<br/>  <br/> But once the train deposits them all in Turin, a dark cloud settles over the Brits’ carefree holiday. After discovering that their elderly traveling companion has been brutally attacked and robbed, the distraught students vow to scour this unfamiliar city and find his assailant.<br/>  <br/> Unbeknownst to the young British visitors, they have something in their possession that ties into a greater, even more terrible crime. Their hunt could have unexpected and very deadly consequences, for now their quarry is hunting them.<br/>  <br/> The Edgar, Agatha, and Gold Dagger Award–winning author of the Brother Cadfael Mysteries is “highly recommended for those who still like a proper five course whodunit with all the trimmings” (<i>The Sunday Times</i>).<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellis Peters
      </h2>
      
      <p class="authorDescription body article">Ellis Peters is a pseudonym of Edith Mary Pargeter (1913&ndash;1995), a British author whose Chronicles of Brother Cadfael are credited with popularizing the historical mystery. Cadfael, a Welsh&#160;Benedictine&#160;monk living at&#160;Shrewsbury Abbey in the first half of the twelfth century, has been described as combining the curious mind of a scientist with the bravery of a knight-errant. The character has been adapted for television, and the books drew international attention to Shrewsbury and its history.<BR />&#160;<BR />Pargeter won an Edgar Award&#160;in 1963 for&#160;<I>Death and the Joyful Woman</I>, and in 1993 she won the&#160;Cartier Diamond Dagger, an annual award given by the&#160;Crime Writers&rsquo; Association of Great Britain. She was appointed&#160;officer of the Order of the British Empire&#160;in 1994, and in 1999 the British&#160;Crime Writers&rsquo; Association&#160;established the&#160;Ellis Peters Historical Dagger&#160;award, later called the Ellis Peters Historical Award.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b61bd8c